import PropTypes from "prop-types";
import React from "react";
// @mui
import { Box, Card, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
// components
import Logo from "src/components/logo";
import Image from "src/components/image";

// ----------------------------------------------------------------------

const MainBanner = ({ src, children }) => (
    <Box position="absolute" overflow="visible" sx={ { top: "150px", right: "150px", bottom: "150px", left: "150px", minWidth: "240px", maxWidth: "2180px", margin: "auto" } }>
        <Box overflow="hidden"
             sx={ {
                 width: 1, height: 1, border: "10px solid white", borderRadius: "30px",
                 filter: "drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.25))",
                 webkitFilter: "drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.25))", /* Safari 兼容 */
                 transform: "translateZ(0)" /* 触发硬件加速 */
             } }
        >
            <Image src={ src } alt="banner" width={ 1 } height={ 1 } sx={ { "& img": { objectPosition: "center" } } } disabledEffect visibleByDefault />
        </Box>

        { children }
    </Box>
);

MainBanner.propTypes = {
    src: PropTypes.string.isRequired,
    //
    children: PropTypes.node.isRequired
};

// ----------------------------------------------------------------------

const MAIN_CONTENTS = [ {
    image: "/assets/icon/navbar/ic_seamless.svg",
    title: "Seamless API Integration",
    content: "No need to manage multiple carrier systems, we’ve done the hard part for you."
}, {
    image: "/assets/icon/navbar/ic_real_time.svg",
    title: "Real-Time Access to Rates",
    content: "Support for USPS, UPS, FedEx, DHL, and more — with up to 90% off."
}, {
    image: "/assets/icon/navbar/ic_built.svg",
    title: "Built for Developers",
    content: "From sandbox testing to production-ready keys, our API is designed to scale."
} ];

// ----------------------------------------------------------------------

export default function AuthModernLayout({ children }) {
    const renderContent = (
        <Stack
            sx={ {
                width: 1,
                mx: "auto",
                height: "100vh",
                px: 2.5,
                pt: 1.25,
                pb: { xs: 2, sm: 2.5 }
            } }
        >
            <Stack direction="row" justifyContent="space-between">
                <Logo />
            </Stack>

            <Card
                sx={ {
                    mt: 0,
                    py: 1.25,
                    px: { xs: 0, sm: "10px" },
                    height: "100%",
                    boxShadow: "none",
                    overflow: { sm: "unset" },
                    overflowY: "auto"
                } }
            >
                { children }
            </Card>
        </Stack>
    );

    // ----------------------------------

    return (
        <Stack bgcolor="background.gray_light">
            <Stack component="main" direction="row" position="absolute" bgcolor="white" zIndex={ 1 } overflow="auto"
                   sx={ {
                       left: "0",
                       top: "0",
                       width: "100%",
                       maxWidth: { xs: "none", sm: "480px" },
                       minHeight: "100vh"
                   } }
            >
                { renderContent }
            </Stack>

            <Stack position="relative" sx={ { display: { xs: "none", sm: "flex" }, paddingLeft: "480px", height: "100vh" } } overflow="scroll">
                <Box
                    sx={ {
                        position: "absolute",
                        top: 0, bottom: 0, left: 0, right: 0,
                        filter: "drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.25))",
                        webkitFilter: "drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.25))", /* Safari 兼容 */
                        transform: "translateZ(0)" /* 触发硬件加速 */
                    } }
                >
                    <Image src="/assets/image/auth/banner_e.jpg" alt="banner" width={ 1 } height={ 1 } objectFit="cover" disabledEffect visibleByDefault />
                </Box>

                <Stack direction="column" spacing="40px" margin="auto" padding="20px" zIndex={ 1 }>
                    { MAIN_CONTENTS.map((item, i) => (
                        <Stack
                            key={ i } direction="column" spacing="10px" width="100%" maxWidth="371px" margin="auto" padding="20px" alignItems="center"
                            sx={ {
                                backgroundColor: alpha("#000000", 0.4),
                                borderRadius: "30px",
                                overflow: "hidden"
                            } }
                        >
                            <Image src={ item.image } alt="banner icon" width={ 60 } height={ 60 } objectFit="contain" disabledEffect visibleByDefault />

                            <Stack direction="column" spacing="4px" margin="auto">
                                <Typography variant="h2" textAlign="center" color="white" noWrap>{ item.title }</Typography>

                                <Typography variant="body1" textAlign="center" color="white">{ item.content }</Typography>
                            </Stack>
                        </Stack>
                    )) }
                </Stack>
            </Stack>
        </Stack>
    );
}

AuthModernLayout.propTypes = {
    children: PropTypes.node
};
